module.exports = __webpack_public_path__ + "img/four.b2754e4b.jpg";